import { connect } from 'react-redux';
import { onRestart } from '../../../reducers/test.reducers';
import Dialog from './test-completed';

const mapStateToProps = state => ({
  open: state.tests.completedDialogOpen,
  correctAnswersCount: state.tests.correctAnswersCount,
  questionCount: state.tests.questions.length,
  selectedExam: state.tests.selectedExam,
});

const mapDispatchToProps = dispatch => ({
  onRestart: () => dispatch(onRestart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dialog);



// WEBPACK FOOTER //
// ./src/app/main/dialogs/test-completed/test-completed.container.js